import { ApolloProvider } from '@apollo/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { useClient } from '../graphql/client';
import { ThemeProvider } from '@mui/material/styles';
import { providerTheme } from './mui-theme';
import AppRoutes from './AppRoutes';
import { queryClient } from '../v2/api/query-client';
import AuthContainer from '../v2/shared/containers/AuthContainer';
import PatientOrgContainer from '../patient/hooks/PatientOrgContainer';

export default function App() {
  const client = useClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ApolloProvider client={client}>
        <AuthContainer.Provider>
          <PatientOrgContainer.Provider>
            <ThemeProvider theme={providerTheme}>
              <RouterProvider router={AppRoutes} />
              <ToastContainer position='bottom-left' />
              <div id='modal-root'></div>
            </ThemeProvider>
          </PatientOrgContainer.Provider>
        </AuthContainer.Provider>
      </ApolloProvider>
    </QueryClientProvider>
  );
}
